import createLiveOrganizationServicesRoute from './helpers/createLiveOrganizationServicesRoute';

const getOrganizationServicesRoute = () => createLiveOrganizationServicesRoute();

export default getOrganizationServicesRoute;
